import { render, staticRenderFns } from "./PlanModal.vue?vue&type=template&id=58837fdd&scoped=true&"
import script from "./PlanModal.vue?vue&type=script&lang=js&"
export * from "./PlanModal.vue?vue&type=script&lang=js&"
import style0 from "./PlanModal.vue?vue&type=style&index=0&id=58837fdd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58837fdd",
  null
  
)

export default component.exports